import Row from '@amzn/meridian/row';
import Tab, { TabGroup } from '@amzn/meridian/tab';
import React from 'react';
import { useAppSelector } from 'src/store/store';
import { useDispatch } from 'react-redux';
import { setJmrFilter } from 'src/store/newJmrPageSlice/newJmrPageSlice';
import { JmrJobTypes } from 'src/utils/jmrUtils';
import SearchField from '@amzn/meridian/search-field';

interface TopOptionsProps {
  searchField?: string;
  setSearchField?: (val: string) => void;
}
const TopOptions = ({ searchField, setSearchField }: TopOptionsProps) => {
  const dispatch = useDispatch();
  const { jmrFilter } = useAppSelector((state) => state.newJmrPage);
  return (
    <Row widths={['fill', 'fit']} alignmentHorizontal="justify" spacingInset={'400 none'} backgroundColor="white">
      <TabGroup value={jmrFilter.jobType} onChange={(jobType) => dispatch(setJmrFilter({ ...jmrFilter, jobType }))}>
        <Tab value={JmrJobTypes.ProcessPath} aria-label="Process Path" data-cy="new-jmr__results__process-path-btn">
          Process Path
        </Tab>
        <Tab value={JmrJobTypes.TLD} aria-label="TLD" data-cy="new-jmr__results__tld-btn">
          TLD
        </Tab>
      </TabGroup>
      {setSearchField !== undefined ? (
        <SearchField
          value={searchField}
          aria-label="Search"
          onChange={setSearchField}
          placeholder="Search for..."
          onSubmit={() => {}}
        />
      ) : (
        <></>
      )}
    </Row>
  );
};

export default TopOptions;
